<section class="tasks-panel flex flex-col bg-card overflow-hidden height-100p">
  <article
    class="tasks-panel__header pl-3 pr-3 pt-2 pb-2 border-b flex items-center"
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="panelDef?.color"
  >
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div
        *ngIf="!changeTitleMode"
        class="font-bold text-md text-secondary uppercase tracking-wider"
        [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
      >
        {{ panelDef.title }}
        <span *ngIf="tasksCount.incomplete === 0 && tasksCount.total !== 0" class="text-sm text-hint font-medium">
          (All tasks complete)
        </span>
        <span *ngIf="tasksCount.incomplete !== 0" class="text-sm text-hint font-medium">
          ({{ tasksCount.incomplete }} pending, {{ tasksCount.completed }} completed)
        </span>
      </div>
    </div>
    <div class="ml-auto">
      <button
        *ngIf="!changeTitleMode && canEditPanelDef"
        mat-icon-button
        type="button"
        [matMenuTriggerFor]="listCardMenu"
      >
        <mat-icon
          class="icon-size-20"
          [svgIcon]="'more_vert'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>
      <mat-menu #listCardMenu="matMenu">
        <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
          <mat-icon [svgIcon]="'edit'"></mat-icon>
          Change Panel Heading
        </button>
        <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
          <mat-icon [svgIcon]="'color_lens'"></mat-icon>
          Heading Color
        </button>
        <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
          <div
            mat-menu-item
            class="gap-2"
            *ngFor="let color of accountColors$ | async"
            (click)="selectHeaderColor(color.name)"
          >
            <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
            {{ color.label }}
          </div>
        </mat-menu>
      </mat-menu>
      <button
        *ngIf="changeTitleMode"
        class="cancel-button"
        mat-icon-button
        type="button"
        [matTooltip]="'Cancel'"
        (click)="toggleEditMode(false)"
      >
        <mat-icon
          [svgIcon]="'cancel'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>
      <button *ngIf="changeTitleMode" mat-icon-button type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
        <mat-icon
          [svgIcon]="'save'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>
    </div>
  </article>

  <ng-container *ngIf="projectTaskLists; else LoadingSpinner">
    <ng-container *ngIf="projectTaskLists.length; else NoTasksToShow">
      <!-- Task List Selector -->
      <article class="tasks-panel__dropdown">
        <mat-form-field class="w-full">
          <mat-select
            placeholder="Select a task list"
            [ngModel]="selectedTaskList.id"
            (selectionChange)="onTaskListChange($event)"
          >
            <mat-option *ngFor="let option of projectTaskLists" [value]="option.id">{{ option?.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </article>

      <mat-divider></mat-divider>

      <!-- Filters Panel -->
      <article class="tasks-panel__filters">
        <ts-button
          type="stroked"
          color="accent"
          [tsOverlayTriggerFor]="filtersOverlayBox"
          [matTooltip]="'Apply filters'"
        >
          <ts-icon icon="ts_filter-list" class="mr-2"></ts-icon>
          Filter
          <ng-container *ngIf="filterCounter">
            <ts-badge [value]="filterCounter" [type]="'info'"></ts-badge>
          </ng-container>
        </ts-button>
      </article>

      <!-- Loading Search Bar -->
      <ng-container *ngIf="isLoading">
        <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
      </ng-container>

      <!-- Tasks Table -->
      <article class="tasks-panel__table flex flex-col overflow-auto">
        @if (newTable) {
        <ts-table [columnDefs]="columnDefs" [rowData]="openTasks" (cellValueChanged)="onCellValueChanged($event)">
        </ts-table>

        <button mat-button (click)="goToTasks()" [color]="'primary'">See all tasks</button>
        } @else {
        <table class="w-full bg-transparent" mat-table matSort [dataSource]="openTasks" [trackBy]="trackByFn">
          <ng-container matColumnDef="is_complete">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
            ></th>
            <td mat-cell *matCellDef="let task">
              <ng-container *ngIf="task.task_type === 'task'">
                <ts-button
                  [icon]="task.is_complete ? 'check_box' : 'check_box_outline_blank'"
                  [type]="'icon'"
                  [color]="task.is_complete ? 'primary' : 'accent'"
                  (click)="toggleCompleted(task)"
                ></ts-button>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="title">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
            >
              <span class="whitespace-nowrap">Task</span>
            </th>
            <td mat-cell *matCellDef="let task">
              <span class="pr-6 whitespace-nowrap cursor-pointer">
                <a (click)="goToTasks(task)">{{ task.title }}</a>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="due_date">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
            >
              <span class="whitespace-nowrap">Due</span>
            </th>
            <td mat-cell *matCellDef="let task">
              <span class="pr-6 whitespace-nowrap">{{ task.due_date | date: 'MMM dd, y, hh:mm aaa' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="assigned_user">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t"
            >
              <span class="whitespace-nowrap">Assigned To</span>
            </th>
            <td mat-cell *matCellDef="let task">
              <span class="pr-6 whitespace-nowrap">{{ task.assigned_user_name }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="tasksFooter">
            <td mat-footer-cell *matFooterCellDef colspan="6" class="border-none">
              <ts-button [type]="'stroked'" (click)="goToTasks()">See all tasks</ts-button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayColumns" class="order-row h-16"></tr>
          <tr mat-footer-row *matFooterRowDef="['tasksFooter']" class="h-16"></tr>
        </table>
        }
      </article>
    </ng-container>
  </ng-container>
</section>

<ng-template #NoTasksToShow>
  <section class="flex flex-col items-center justify-center h-full p-8">
    <mat-icon class="icon-size-40" [svgIcon]="'check_circle_outline'"></mat-icon>
    <p class="text-2xl text-secondary font-medium mt-4">No Tasks Associated</p>
    <p class="text-sm text-secondary mt-2">Tasks added from Tasks tab will be displayed here.</p>
  </section>
</ng-template>

<ng-template #LoadingSpinner>
  <section class="tasks-panel__content flex flex-col items-center justify-center h-full py-8">
    <mat-progress-spinner [diameter]="60" [mode]="'indeterminate'"></mat-progress-spinner>
  </section>
</ng-template>

<!-- List Filters Panel -->
<ts-overlay
  #filtersOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onCloseByBackdropClick()"
>
  <ts-filter
    size="large"
    [fields]="typeFields | async"
    [filters]="filterValueList | async"
    [hasGroups]="false"
    (addItem)="onAddFilterItem()"
    (filterDefChange)="onFilterDefChanged($event)"
    (filterRemove)="onFilterRemoved($event)"
    (filterClear)="onFilterCleared()"
    (filterApply)="onFilterApplied()"
  ></ts-filter>
</ts-overlay>
